module.exports = __webpack_public_path__ + "static/media/trashDelete.95d58ec9.svg";